<template>
  <a-modal
    title="原料营养指标比对"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
    okText='确定'
    cancelText='取消'
    destroyOnClose 
    :maskClosable="false"
    width="900px"
    :footer="false"
  >
    <a-table :scroll='{y: 260}' bordered :columns="columns" :data-source="list" :pagination="false" rowKey="id">
      <template slot="name">
        <p class="thStyle" style="padding-left: 28px">原料信息</p>
        <div style="padding-bottom: 5px;">
          <a-checkbox v-model="checkHide">
            隐藏相同数值项
          </a-checkbox>
        </div>
        <div style="padding-bottom: 5px;">
          <type-cascader @changeForm="changeForm" feild="nutritionTypeId" category='nutritiontarget' />
        </div>
      </template>
      <template slot="compareOne">
        <p class="thStyle">{{compareOne.name ? compareOne.name : '选择原料'}}</p>
        <div>
          <a @click="() => openContras('compareOne')">添加原料</a>
        </div>
      </template>
      <template slot="compareTwo">
        <p class="thStyle">选择原料</p>
        <div>
          <a @click="() => openContras('compareTwo')">添加原料</a>
        </div>
      </template>
      <template slot="different">
        <p class="thStyle">差异</p>
      </template>
    </a-table>
    <add-contrast :visible="addContrastVisible" @close="closeAddContras" />
  </a-modal>
</template>

<script>
import TypeCascader from '../CommonConponents/TypeCascader.vue'
import AddContrast from './AddContrastModal.vue'
export default {
  props: ['visible'],
  components: {TypeCascader,AddContrast},
  data(){
    return {
      list: [],
      columns: [
        {
          dataIndex: "name",
          width: 160,
          ellipsis: true,
          slots: { title: "name" },
          scopedSlots: { customRender: "nameContent" },
        },
        {
          dataIndex: "compareOne",
          width: 160,
          ellipsis: true,
          slots: { title: "compareOne" },
          align: 'center'
        },
        {
          dataIndex: "compareTwo",
          width: 160,
          ellipsis: true,
          slots: { title: "compareTwo" },
          align: 'center'
        },
        {
          dataIndex: "different",
          width: 160,
          ellipsis: true,
          slots: { title: "different" },
          align: 'center'
        },
      ],
      compareOne: {},
      compareTwo: {},
      checkHide: false,
      formData: {},
      addContrastVisible: false,
      chooseFeild: '',
    }
  },
  methods: {
    ok(){
      this.$emit('close')
    },
    cancel(){
      this.$emit('close')
    },
    changeForm(data){
      this.formData = {...this.formData,...data}
      console.log('formData',this.formData)
    },
    openContras(type){
      this.chooseFeild = type
      this.addContrastVisible = true
    },
    closeAddContras(type,data){
      console.log('data',data)
      if(type){
        this[this.chooseFeild] = data
      }
      this.chooseFeild = ''
      this.addContrastVisible = false
    },
  }
}
</script>
<style lang="scss" scoped>
.thStyle{
  color: orange;
  margin: 0;
  font-size: 14px;
}
</style>